var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"CustomHead"},[_c('div',{staticClass:"headerStatus"},[_c('img',{class:{loading: _vm.srcName === 'loading.png'},attrs:{"src":_vm.isSrcName,"alt":""}}),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }